import { StatsTile } from "@certn/report/components/stats-tile/StatsTile";
import { css } from "@emotion/css";
import { ControlProps } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import React from "react";
import { useTranslation } from "react-i18next";

import { handleMissingAndBlankData, formatData } from "../utils";

export function StatsTileControl(props: ControlProps) {
  const { t } = useTranslation();

  function transformData(data: ControlProps["data"], format: string) {
    data = handleMissingAndBlankData(data);
    if (data === "--") return data;

    return formatData(data, format, t);
  }

  if (!props.visible) {
    return null;
  }

  const options = props.uischema.options || {};
  const results = props.data;

  return (
    <StatsTile
      label={props.label}
      value={transformData(results, options.format)}
      testId={options.testId}
      popoverHeading={options.popoverHeading}
      popoverContent={options.popoverContent}
      popoverActionUrl={options.popoverActionUrl}
      className={styles.container}
    />
  );
}

const styles = {
  container: css({
    height: "100%",
    justifyContent: "space-between",
  }),
};

export const StatsTileRenderer = withJsonFormsControlProps(StatsTileControl);
